export enum DiscoutRules {
  TICKER = 'TICKER', //Discount only can be added to a transaction with specific ticker.
  EMAIL = 'EMAIL', //Discount owned by an user.
  EXPIRE_ON = 'EXPIRE_ON', //Discount only can be added before the expireOn date.
  MAX_COUNT = 'MAX_COUNT', //Discount only can be added n times.
}
